<template>
  <div class="accordion">
    <slot :isOpen="isOpen" :handleFocus="handleSectionFocus" />
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    captions: {
      type: Boolean
    }
  },

  data() {
    return {
      isOpen: -1
    };
  },
  computed: {
    currentAudio() {
      return this.$store.state.currentAudio;
    },
    playState() {
      return this.$store.state.audioPlayState;
    }
  },
  methods: {
    handleSectionFocus(openID) {
      if (this.isOpen === openID) {
        this.$store.commit("setFocus", false);
        this.isOpen = -1;
      } else {
        this.$store.commit("setFocus", true);
        this.isOpen = openID;
      }
      if (this.playState) {
        this.$store.commit("setAudioPlayState", false);
        this.currentAudio.pause();
      }
    }
  }
};
</script>

<style lang="scss">
#open-div {
  border-bottom: unset !important;
  div {
    border-bottom: unset !important;
  }
}

.accordion {
  p {
    color: $white;
  }

  div {
    border-bottom: 1px solid $white;

    &:first-child {
      .card-header {
        border-radius: 10px 10px 0 0;
      }
    }

    &:last-child:not(#open-div) {
      border-bottom: unset;
      .card-header {
        border-radius: 0 0 10px 10px;
      }
    }

    &:last-child {
      border-bottom: unset;
      .accordion-content {
        border-radius: 0 0 10px 10px;
      }
    }
  }
}
</style>
